import React from "react";
import { useParams } from "react-router-dom";

import FirstLocationRedirect from "@/components/FirstLocationRedirect.tsx";
import ManageTemplates from "@/components/ManageTemplates.tsx";
import ManageUsers from "@/components/ManageUsers.tsx";
import ChannelsTable from "@/components/MiddleTableNavigation/ChannelsTable.tsx";
import ScheduledMessages from "@/components/ScheduledMessages.tsx";
import YourProfile from "@/components/YourProfile.tsx";
import LiveFeedPage from "@/features/western-express/integration/LiveFeedPage";
import TasksPage from "@/features/western-express/integration/TasksPage";

export default function SubPage() {
  const { subPage } = useParams();

  if (subPage === "tasks") {
    return <TasksPage />;
  }

  if (subPage === "live-feed") {
    return <LiveFeedPage />;
  }

  if (subPage === "scheduled-messages") {
    return <ScheduledMessages />;
  }

  if (subPage === "manage-users") {
    return <ManageUsers />;
  }

  if (subPage === "manage-templates") {
    return <ManageTemplates />;
  }

  if (subPage === "your-profile") {
    return <YourProfile />;
  }

  if (subPage === "channels") {
    return <ChannelsTable />;
  }

  if (subPage === "drivers") {
    return <FirstLocationRedirect />;
  }

  return <>No Sub Page Found</>;
}
